/* Opens the bundle badge tooltip on click, tap or keyboard without following
   the card link.

   Listens in the CAPTURE phase, and that is the whole trick. Horizon's
   <product-card> has its own click handler (assets/product-card.js) which does:

       const targetLink = event.target.closest('a');
       if (!targetLink) this.#navigateToURL(event, linkURL);

   The card's <a> wraps only the slideshow, so a badge click has no anchor
   ancestor and the component navigates PROGRAMMATICALLY. preventDefault does
   not stop that, and a bubble-phase listener on document runs too late — the
   element's own handler has already fired. Capturing on document runs first,
   and stopPropagation then means the card handler never sees the event at all.

   Hover is handled in CSS. Loaded from layout/theme.liquid. */
(function () {
  if (window.__guamBundleTipBound) return;
  window.__guamBundleTipBound = true;

  function closeAll(except) {
    document.querySelectorAll('.guam-bundle-badge[data-open]').forEach(function (el) {
      if (el !== except) {
        el.removeAttribute('data-open');
        el.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function toggle(el) {
    if (el.hasAttribute('data-open')) el.removeAttribute('data-open');
    else el.setAttribute('data-open', '');
  }

  /* On a hover-capable pointer the tooltip is already shown on hover, so there
     is nothing for a click to reveal — intercepting it would only freeze the
     tooltip and swallow a click the shopper meant for the card. So on desktop
     we do not intercept at all and the click navigates naturally: on the
     collection grid it bubbles to <product-card>, whose own handler calls
     #navigateToURL because the badge has no <a> ancestor; in the two widgets
     the badge sits inside the card's <a>, so the anchor handles it.
     Touch has no hover, so there the tap must open the tooltip. Evaluated per
     event rather than once at load, so a hybrid device that gains or loses a
     mouse is handled. */
  function pointerHovers() {
    return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  }

  function badgeFrom(event) {
    var t = event.target;
    return (t && t.closest) ? t.closest('.guam-bundle-badge') : null;
  }

  function activate(event) {
    var badge = badgeFrom(event);
    closeAll(badge);
    if (!badge) return;
    // Desktop: let the click through so the badge behaves like the rest of the card.
    if (event.type === 'click' && pointerHovers()) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    toggle(badge);
    badge.setAttribute('aria-expanded', badge.hasAttribute('data-open') ? 'true' : 'false');
  }

  document.addEventListener('click', activate, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { closeAll(null); return; }
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!badgeFrom(event)) return;
    activate(event);
  }, true);
})();
